export const testItemAxel = {
    id: 'AXS',
    name: 'Axel Strömberg',
    detailedName: 'Axel Strömberg (Stockholm)',
    link: '/employee/axs/info',
};

export const competences = [
    {
        id: 'NET',
        name: '.NET',
    },
    {
        id: 'JSC',
        name: 'Javascript',
    },
    {
        id: 'CPP',
        name: 'C/C++',
    },
    {
        id: 'AND',
        name: 'Android',
    },
    {
        id: 'IOS',
        name: 'iOS',
    },
];

export const cities = [
    {
        id: 'STH',
        name: 'Stockholm',
    },
    {
        id: 'GBG',
        name: 'Göteborg',
    },
    {
        id: 'JON',
        name: 'Jönköping',
    },
];

export const labels = [
    {
        id: 'CSA',
        name: 'Customer (A)',
        description: 'Möjlig kundvolym >40 FTE på årsbasis.',
        color: '#145A32',
    },
    {
        id: 'CSB',
        name: 'Customer (B)',
        description: 'Möjlig kundvolym 5-40 FTE på årsbasis.',
        color: '#07a742',
    },
    {
        id: 'CSC',
        name: 'Customer (C)',
        description: 'Möjlig kundvolym <5 FTE på årsbasis.',
        color: '#1f618d',
    },
    {
        id: 'CSD',
        name: 'Customer (D)',
        description: 'Låg möjlig kundvolym.',
        color: '#2e86c1',
    },
    {
        id: 'LEA',
        name: 'Lead (A- & B-prospekt)',
        description: 'Potential till >5 FTE på årsbasis.',
        color: '#f94839',
    },
    {
        id: 'LEC',
        name: 'Lead (C-prospekt)',
        description: 'Potential till <5 FTE på årsbasis.',
        color: '#f39C12',
    },
    {
        id: 'LED',
        name: 'Lead (D-prospekt)',
        description: 'Mindre potential.',
        color: '#ffcc00',
    },
    {
        id: 'CLD',
        name: 'Cold Lead',
        description: 'Okänd potential.',
        color: '#e5e5e5',
    },
    {
        id: 'UKB',
        name: 'UK-Bolag',
        description: 'Underkonsultbolag.',
        color: '#5d6d7',
    },
];

export const lostReasons = [
    {
        id: 'A',
        name: 'Konkurrent hade lägre pris',
    },
    {
        id: 'B',
        name: 'Kund anser att vi saknade kompetens',
    },
    {
        id: 'C',
        name: 'Dålig intervju',
    },
    {
        id: 'D',
        name: 'Consid alternativt UK säljer konsult till annat uppdrag',
    },
    {
        id: 'E',
        name: 'Kund drog tillbaka förfrågan/Avbruten affär',
    },
    {
        id: 'F',
        name: 'Vi presenterade ingen konsult',
    },
    {
        id: 'G',
        name: 'Riktad affär',
    },
    {
        id: 'H',
        name: 'Övrigt',
    },
];

export const roles = [
    {
        id: 'CHF',
        name: 'Chef',
    },
    {
        id: 'CIO',
        name: 'CIO',
    },
    {
        id: 'MRK',
        name: 'Marknadschef',
    },
    {
        id: 'CON',
        name: 'Konsult',
    },
    {
        id: 'PRJ',
        name: 'Projektledare',
    },
];

export const pipelines = [
    {
        id: 'A',
        name: 'Pipeline A',
        order: 0,
        pipelineStages: [
            {
                id: 'A1',
                pipelineId: 'A',
                name: 'A. Stage 1 - Really long name for a pipeline stage',
                order: 0,
            },
            {
                id: 'A2',
                pipelineId: 'A',
                name: 'A. Stage 2',
                order: 1,
            },
            {
                id: 'A3',
                pipelineId: 'A',
                name: 'A. Stage 3',
                order: 2,
            },
            {
                id: 'A4',
                pipelineId: 'A',
                name: 'A. Stage 4',
                order: 3,
            },
            {
                id: 'A5',
                pipelineId: 'A',
                name: 'A. Stage 5',
                order: 4,
            },
            {
                id: 'A6',
                pipelineId: 'A',
                name: 'A. Stage 6',
                order: 5,
            },
            {
                id: 'A7',
                pipelineId: 'A',
                name: 'A. Stage 7',
                order: 6,
            },
        ],
    },
    {
        id: 'C',
        name: 'Pipeline C',
        order: 2,
        pipelineStages: [
            {
                id: 'C2',
                pipelineId: 'C',
                name: 'C. Stage 2',
            },
            {
                id: 'C3',
                pipelineId: 'C',
                name: 'C. Stage 3',
            },
            {
                id: 'C1',
                pipelineId: 'C',
                name: 'C. Stage 1',
                order: 0,
            },
        ],
    },
    {
        id: 'B',
        name: 'Pipeline B',
        order: 1,
        pipelineStages: [
            {
                id: 'B3',
                pipelineId: 'B',
                name: 'B. Stage 3',
                order: 2,
            },
            {
                id: 'B2',
                pipelineId: 'B',
                name: 'B. Stage 2',
                order: 1,
            },
            {
                id: 'B1',
                pipelineId: 'B',
                name: 'B. Stage 1',
                order: 0,
            },
            {
                id: 'B4',
                pipelineId: 'B',
                name: 'B. Stage 4',
            },
        ],
    },
];
